import React from "react";
import config from "../config/config";
import productData from "../scripts/productData";

const Content1 = ({ pageName }) => {
  const pageData = productData[pageName] || { description: "", products: [] };

  return (
    <div className="container py-5">
      {/* Page Description */}
      <div className="section-title text-center">
        <p>{pageData.description}</p>
      </div>

      {/* Check if products exist before mapping */}
      {Array.isArray(pageData.products) && pageData.products.length > 0 ? (
        pageData.products.map((product, index) => (
          <div 
            className="row d-flex align-items-center mb-5" 
            key={index}
          >
            {/* Product Image */}
            <div 
              className={`col-12 col-md-6 text-center mb-3 mb-md-0 ${index % 2 === 1 ? "order-md-2" : "order-md-1"}`}
            >
              <img
                src={config.PUBLIC_URL + product.image}
                className="img-fluid"
                alt={product.title}
              />
            </div>

            {/* Product Details */}
            <div 
              className={`col-12 col-md-6 ${index % 2 === 1 ? "order-md-1" : "order-md-2"}`}
            >
              <h5>{product.title}</h5>
              <table className="table table-bordered mt-3">
                <thead>
                  <tr>
                    <th>Specification</th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  {product.specifications.map((spec, i) => (
                    <tr key={i}>
                      <td>{spec.label}</td>
                      <td>{spec.value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <p>{product.description}</p>
              {product.details && <p><strong>Details:</strong> {product.details}</p>}
              {product.features && (
                <>
                  <p><strong>Features:</strong></p>
                  <ul>
                    {product.features.map((feature, i) => (
                      <li key={i}>{feature}</li>
                    ))}
                  </ul>
                </>
              )}
            </div>
          </div>
        ))
      ) : (
        <p className="text-center">No products available for this category.</p>
      )}
    </div>
  );
};

export default Content1;
